import { render, staticRenderFns } from "./TaxDeduction.vue?vue&type=template&id=419debc4"
import script from "./TaxDeduction.vue?vue&type=script&lang=js"
export * from "./TaxDeduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports